const accountingParameters = {
    payrollTaxes: {
        taxeApprentissageRate: 0.68,
        contributionSupplementaireALApprentissageRate: 0.40,
        taxeSurLesSalairesRate: 4.25,
        contributionUniqueALaFormationRate: 0.55,
        contributionEffortConstructionRate: 0.45
    },
    vats: [0, 2.1, 5.5, 8.5, 10, 20], // TAUX TVA 8.5
    depreciationDurations: [
        {
            name: "201000", // frais établissement
            defaultYearDuration: 5,
            minYearDuration: 3,
            maxYearDuration: 5,
            linearDepreciation: true
        },
        {
            name: "201100", // frais constitution
            defaultYearDuration: 5,
            minYearDuration: 3,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "201200",
            defaultYearDuration: 5,
            minYearDuration: 5,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "201210",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "201220",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "201300",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "203000", // recherche et développement
            defaultYearDuration: 5,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "205000", // Brêvets, licences, ...
            defaultYearDuration: 10,
            minYearDuration: 3,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "206000",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "207000",
            defaultYearDuration: 10,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "208000",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "211000",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "211100",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "211200",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "211300",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "211400",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "211410",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "211500",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "211510",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "211550",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "211580",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "211581",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "211588",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "211600",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "212000",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "213000",
            defaultYearDuration: 25,
            minYearDuration: 10,
            maxYearDuration: 100,
            linearDepreciation: true
        },
        {
            name: "213100",
            defaultYearDuration: 25,
            minYearDuration: 10,
            maxYearDuration: 100,
            linearDepreciation: true
        },
        {
            name: "213110", // bât industriels
            defaultYearDuration: 25,
            minYearDuration: 10,
            maxYearDuration: 100,
            linearDepreciation: true
        },
        {
            name: "213150", // bât administratifs ou commerciaux
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "213180",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "213181",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "213188", // Immobilier autre - affecté aux opérations non professionnelles
            defaultYearDuration: 0,
            minYearDuration: 40,
            maxYearDuration: 100,
            linearDepreciation: true
        },
        {
            name: "213500", // Installations générales, agencements
            defaultYearDuration: 10,
            minYearDuration: 5,
            maxYearDuration: 20,
            linearDepreciation: true
        },
        {
            name: "213800",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "213810",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "213820",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "213830",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "213840",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "213850",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "214000",
            defaultYearDuration: 10,
            minYearDuration: 5,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "215000",
            defaultYearDuration: 7,
            minYearDuration: 5,
            maxYearDuration: 10,
            linearDepreciation: true
        },
        {
            name: "215100",
            defaultYearDuration: 10,
            minYearDuration: 5,
            maxYearDuration: 10,
            linearDepreciation: true
        },
        {
            name: "215110",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "215140",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "215300",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "215310",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "215340",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "215400", // matériel industriel
            defaultYearDuration: 7,
            minYearDuration: 5,
            maxYearDuration: 10,
            linearDepreciation: true
        },
        {
            name: "215500", // outillage industriel
            defaultYearDuration: 7,
            minYearDuration: 5,
            maxYearDuration: 10,
            linearDepreciation: true
        },
        {
            name: "215700",
            defaultYearDuration: 10,
            minYearDuration: 5,
            maxYearDuration: 15,
            linearDepreciation: true
        },
        {
            name: "218000",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "218100", // Installations générales, agencements, aménagéments divers
            defaultYearDuration: 10,
            minYearDuration: 5,
            maxYearDuration: 15,
            linearDepreciation: true
        },
        {
            name: "218200", // matériel de transport
            defaultYearDuration: 5,
            minYearDuration: 3,
            maxYearDuration: 10,
            linearDepreciation: true
        },
        {
            name: "218300", // matériel de bureau et informatique
            defaultYearDuration: 3,
            minYearDuration: 2,
            maxYearDuration: 7,
            linearDepreciation: true
        },
        {
            name: "218400", // mobilier
            defaultYearDuration: 7,
            minYearDuration: 3,
            maxYearDuration: 10,
            linearDepreciation: true
        },
        {
            name: "218500",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "218600",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "220000",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "231000",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "231200",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "231300",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "231500",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "231800",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "232000",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "237000",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "238000",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "238200",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "238300",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "238500",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        },
        {
            name: "238800",
            defaultYearDuration: 0,
            minYearDuration: null,
            maxYearDuration: null,
            linearDepreciation: true
        }
    ]
}

export function getPayrollTaxesRates() {
    return accountingParameters.payrollTaxes
}

export function getVats() {
    return accountingParameters.vats
}

export function getDepreciationDurations() {
    return accountingParameters.depreciationDurations
}
